import { create } from 'zustand';
import { mockSchedules } from '../data/mockSchedules';
import type { Schedule } from '../schemas';

interface ScheduleState {
  schedules: Schedule[];
  isLoading: boolean;
  addSchedule: (schedule: Omit<Schedule, 'id' | 'createdAt' | 'updatedAt'>) => void;
  updateSchedule: (id: string, updates: Partial<Schedule>) => void;
  deleteSchedule: (id: string) => void;
  getSchedule: (id: string) => Schedule | undefined;
}

export const useScheduleStore = create<ScheduleState>()((set, get) => ({
  schedules: mockSchedules,
  isLoading: false,
  addSchedule: schedule => {
    const newSchedule: Schedule = {
      ...schedule,
      id: Math.random().toString(36).substr(2, 9),
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString(),
    };
    set(state => ({ schedules: [...state.schedules, newSchedule] }));
  },
  updateSchedule: (id, updates) => {
    set(state => ({
      schedules: state.schedules.map(s =>
        s.id === id ? { ...s, ...updates, updatedAt: new Date().toISOString() } : s,
      ),
    }));
  },
  deleteSchedule: id => {
    set(state => ({ schedules: state.schedules.filter(s => s.id !== id) }));
  },
  getSchedule: id => {
    return get().schedules.find(s => s.id === id);
  },
}));
